import { render, staticRenderFns } from "./CreateEditVoting.vue?vue&type=template&id=d97cbbb4&scoped=true&"
import script from "./CreateEditVoting.vue?vue&type=script&lang=js&"
export * from "./CreateEditVoting.vue?vue&type=script&lang=js&"
import style0 from "./CreateEditVoting.vue?vue&type=style&index=0&id=d97cbbb4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97cbbb4",
  null
  
)

export default component.exports